import { EMedicalCategoryType } from '@/entities/medical-category';
import useAuthModal from '@/hooks/useAuthModal';
import useNavigate from '@/hooks/useNavigate';
import { getAuthToken } from '@/recoil/atoms/common/auth';
import { ROUTES } from '@/types/common';
import { useRouter } from 'next/router';
import { BRIDGE_PAGE_CATEGORIES } from '../constants';

const WEB_DIAGNOSIS_DISABLED_CATEGORIES = [
  {
    id: '12',
    category: EMedicalCategoryType.TREATMENT,
  },
];

export interface TelemedicineRequestProps {
  type: EMedicalCategoryType;
  categoryId: string;
  redirectUrl: string;
}

const useTelemedicineRequest = () => {
  const { setShowAuthModal } = useAuthModal(true, false);
  const navigate = useNavigate();
  const router = useRouter();
  const token = getAuthToken();

  const getIsEnabledWebTelemedicineCategory = (categoryId: string) => {
    return !WEB_DIAGNOSIS_DISABLED_CATEGORIES.some((category) => category.id === categoryId);
  };

  const getIsBridgePageCategory = (categoryId: string): boolean => {
    return BRIDGE_PAGE_CATEGORIES.includes(categoryId);
  };

  const onClickTelemedicineRequest = ({ categoryId, type, redirectUrl }: TelemedicineRequestProps) => {
    const isBridgePageCategory = getIsBridgePageCategory(categoryId);

    if (!token) {
      if (isBridgePageCategory) {
        const bridgePath = ROUTES.TELEMEDICINE.BRIDGE.buildPath(categoryId as string, type, redirectUrl);
        router.push(bridgePath);
        return;
      }

      setShowAuthModal(
        true,
        redirectUrl,
        '3초만에 로그인하고\n비대면 진료 시작해보세요',
        '앱 설치할 필요 없이 바로 진료받을 수 있어요.'
      );
      return;
    }

    const isEnabledWebTelemedicineCategory = getIsEnabledWebTelemedicineCategory(categoryId);
    if (isEnabledWebTelemedicineCategory) {
      navigate.navigateToTelemedicineRequestScreen({
        categoryId,
        type,
      });
      return;
    }

    router.push(redirectUrl);
  };

  return {
    onClickTelemedicineRequest,
  };
};

export default useTelemedicineRequest;
